import {
  Backdrop,
  BackdropRoot,
  IconButton,
  InputAdornment,
  TextField,
  ThemeProvider,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
// import AccessLevel from "./AccessLevel";
import { createTheme } from "@mui/material/styles";
import Swal from "sweetalert2";

import { common_axios } from "../../../../App";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import Loader from "../../../../components/Loader";

export default function AssignSenderId() {
  const [open, setOpen] = useState(false);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [Status, setStatus] = useState({
    resellerName: null,
    senderId: null,
  });

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  const fetchUser = async () => {
    try {
      setOpen(true);
      const res = common_axios.post(
        `http://192.168.167.66:5050/admin-master/v1/resellers`
      );
      const res1 = common_axios.post(
        `http://192.168.167.66:5050/admin-master/v1/senderids`,
        { approved: 1, resellerName: null, type: null }
      );

      await Promise.all([res, res1]).then((values) => {
        // console.log({ values });

        if (
          values[0].data.statusDescription.statusCode == 200 &&
          values[1].data.statusDescription.statusCode == 200
        ) {
          setData1(values[0].data.listResellerNames);
          setData2(values[1].data.listSenderId);

          setOpen(false);
        } else {
          setOpen(false);
          // toast.error(values[0].data.statusDescription.statusMessage, {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "error",
             title: "Oops...",
            text:values[0].data.statusDescription.statusMessage,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      });

      // console.log({ res, res1 });
    } catch (error) {
      setOpen(false);
      // console.log(error);
      // await toast.error("Something went wrong", {
      //   theme: "colored",
      // });

      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  useEffect(async () => {
    fetchUser();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setOpen(true);
      const res = await common_axios.post(
        `http://192.168.167.66:5050/admin-master/v1/assign/senderId`,
        {
          resellerName: Status.resellerName,
          senderId: Status.senderId,
        }
      );

      if (res.data.statusDescription.statusCode == 200) {
        fetchUser();
        setOpen(false);

        // await toast.success("Sender Id has been Assigned Successfully", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text:"Sender Id has been Assigned Successfully!!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);

        // await toast.error(res.data.statusDescription.statusMessage, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);

      // await toast.error("Something went wrong", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      <Backdrop
        sx={{
          transform: "translateZ(0)",
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        // onClick={handleClose}
      >
        <Loader />
      </Backdrop>
      <ThemeProvider theme={theme}>
        <div className="container-fluid">
          <div className="card">
            <div className="card-header p-3 pt-2">
              <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                <i className="material-icons opacity-10">person</i>
              </div>
              <div className="pt-1">
                <p
                  className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                  style={{ marginLeft: "70px" }}
                >
                  Assign Sender Id`s
                </p>
                <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
                  Field(s) marked with{" "}
                  <span className="text-danger fw-bold">*</span> are mandatory.
                </p>
              </div>
            </div>
            <div className="card-body">
              <div className="card shadow-none border bg_blue">
                <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                  Details
                </span>

                <form
                  onSubmit={handleSubmit}
                  className="card-body text-lg-start text-center"
                >
                  <div className="d-flex justify-content-between my-3">
                    <Autocomplete
                      required
                      disablePortal
                      id="combo-box-demo"
                      options={data1}
                      sx={{ width: 300 }}
                      // value={Status.resellerName}
                      onChange={(e, val) => {
                        // console.log({ val });
                        setStatus({
                          ...Status,
                          resellerName: val,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          label="Select Reseller"
                        />
                      )}
                    />

                    <div className="d-flex justify-content-between w-25">
                      <Autocomplete
                        required
                        disablePortal
                        id="combo-box-demo"
                        getOptionLabel={(option) => option.senderId}
                        options={data2}
                        sx={{ width: 300 }}
                        // value={Status.resellerName}
                        onChange={(e, val) => {
                          val == null
                            ? setStatus({
                                ...Status,
                                senderId: null,
                              })
                            : setStatus({
                                ...Status,
                                senderId: val.senderId,
                              });
                        }}
                        renderInput={(params) => {
                          return (
                            <TextField
                              required
                              {...params}
                              label="Select Sender Id"
                            />
                          );
                        }}
                      />
                    </div>

                    <div className="d-flex justify-content-between">
                      <button type="submit" className="btn btn-primary">
                        Assign Sender Id
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </ThemeProvider>
    </main>
  );
}
